import { getImageProxyURL, ImageProxyOptions } from '@tests/types';

import { useConfig } from '../hooks/useConfig';

interface IGetImageUrlParams {
  options?: Partial<ImageProxyOptions>;
  url?: string;
}

export const useGetImageUrl = () => {
  const config = useConfig();

  return ({ options, url }: IGetImageUrlParams): string => {
    if (!url || !config?.imageProxyUrl) {
      return url ?? '';
    }

    const baseImageProxyOptions = {
      format: 'webp',
      imageProxyURL: config.imageProxyUrl,
      quality: 95,
    };

    if (url.indexOf('_ani_') > -1 || url.indexOf('.gif') > -1) {
      return url;
    }

    return getImageProxyURL(url, { ...baseImageProxyOptions, ...options });
  };
};
